import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { User, GitHubOrganization } from '@/types'

interface AuthState {
  user: User | null
  accessToken: string | null
  refreshToken: string | null
  expiresAt: string | null
  isAuthenticated: boolean
  // GitHub org selection state
  pendingGitHubToken: string | null
  availableOrgs: GitHubOrganization[] | null
  setAuth: (user: User, accessToken: string, refreshToken: string, expiresAt: string) => void
  setUser: (user: User) => void
  setTokens: (accessToken: string, refreshToken: string, expiresAt: string) => void
  logout: () => void
  setPendingOrgSelection: (token: string, orgs: GitHubOrganization[]) => void
  clearPendingOrgSelection: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      expiresAt: null,
      isAuthenticated: false,
      pendingGitHubToken: null,
      availableOrgs: null,

      setAuth: (user, accessToken, refreshToken, expiresAt) =>
        set({
          user,
          accessToken,
          refreshToken,
          expiresAt,
          isAuthenticated: true,
          pendingGitHubToken: null,
          availableOrgs: null,
        }),

      setUser: (user) =>
        set({ user }),

      setTokens: (accessToken, refreshToken, expiresAt) =>
        set({ accessToken, refreshToken, expiresAt }),

      logout: () =>
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          expiresAt: null,
          isAuthenticated: false,
          pendingGitHubToken: null,
          availableOrgs: null,
        }),

      setPendingOrgSelection: (token, orgs) =>
        set({
          pendingGitHubToken: token,
          availableOrgs: orgs,
        }),

      clearPendingOrgSelection: () =>
        set({
          pendingGitHubToken: null,
          availableOrgs: null,
        }),
    }),
    {
      name: 'oncall-auth',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        expiresAt: state.expiresAt,
        isAuthenticated: state.isAuthenticated,
        pendingGitHubToken: state.pendingGitHubToken,
        availableOrgs: state.availableOrgs,
      }),
    }
  )
)
